<template>
  <v-row>
    <v-col cols="12" lg="12">
      <!-- <SumarryReports isActive="activated"></SumarryReports> -->
    </v-col>
    <v-col cols="12" lg="12">
      <v-card>
        <v-toolbar flat>
          <v-col cols="12" class="px-0">
            <div class="d-flex align-center">
              <div class="text-left">
                <v-toolbar-title class="page-title">
                  Search
                </v-toolbar-title>
              </div>
              <div class="ml-auto">
                <!-- <v-btn color="primary" @click="addOlt()">
                  <v-icon class="mr-2">mdi-plus</v-icon> Add
                </v-btn> -->
                <!-- <v-btn color="primary" class="ml-2" @click="goBack()">
                  <v-icon class="mr-2">mdi-plus</v-icon> Add Serial
                </v-btn> -->
              </div>
            </div>
          </v-col>
          <v-spacer></v-spacer>
        </v-toolbar>

        <v-divider></v-divider>

        <v-card-title>
          <v-text-field
            v-model="serial"
            append-icon="mdi-magnify"
            label="Search Serial Number"
            single-line
            hide-details
            @keypress.enter.prevent="searchSerial()"
          ></v-text-field>
        </v-card-title>
        <v-data-table
          :headers="table.headers"
          :items="table.data"
          :items-per-page="10"
          :loading="table.loading"
          item-key="id"
          :search="search"
          loading-text="Loading... Please wait"
          class="elevation-1"
        >
          <template
            v-for="header in table.headers.filter((header) =>
              header.hasOwnProperty('formatter')
            )"
            v-slot:[`item.${header.value}`]="{ value }"
          >
            {{ header.formatter(value) }}
          </template>

          <!-- <template v-slot:[`item.referenceNumber`]="{ item }">
            <a href="#" @click.prevent="searchOlt(item)">{{
              item.referenceNumber
            }}</a>
          </template> -->
        </v-data-table>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import moment from "moment";
// import OnuList from "../dialogs/management/OnuList.vue";
export default {
  name: "SearchInventory",
  components: {
    // OnuList,
  },
  data() {
    return {
      search: "",
      serial: "",
      table: {
        expanded: [],
        singleExpand: false,
        // sortBy: "dtCreated",
        sortDesc: true,
        loading: false,
        headers: [
          {
            text: "Serial Number",
            sortable: false,
            value: "serialNumber",
          },
          {
            text: "Released by",
            sortable: false,
            value: "releasedBy",
          },
          {
            text: "Received by",
            sortable: false,
            value: "receivedBy",
          },

          {
            text: "Status",
            sortable: false,
            value: "status",
          },

          {
            text: "Activation Date",
            sortable: false,
            value: "activationDate",
            formatter: (x) =>
              x ? moment(x).format("MMM DD, YYYY h:mm:ss A") : null,
          },
        ],
        data: [],
      },
    };
  },
  // props: ["tableAPIUrl", "reload", "headers"],

  methods: {
    async searchSerial() {
      this.table.loading = true;
      await this.$api
        .post("/inventory-search", { serialNumber: this.serial })
        .then((response) => {
          const newArr = response.data.data.list;
          this.table.data = newArr;
          this.table.loading = false;
        })
        .catch((e) => {
          this.table.loading = false;
          console.log(e);
        });
    },

    // async searchOlt(item) {
    //   const list = await this.$api
    //     .post("/tech/search-olt", { referenceNumber: item.referenceNumber })
    //     .then((response) => {
    //       const newArr = response.data.data.list;
    //       // console.log(newArr);
    //       return newArr;
    //     })
    //     .catch((e) => {
    //       this.table.loading = false;
    //       console.log(e);
    //     });
    //   await this.$refs.onuList.open(list);
    // },
  },
  created() {
    // this.getList();
    // console.log(this.$props.headers);
  },

  watch: {
    // reload(val) {
    //   this.getDrawList(val);
    // },
  },

  computed: {
    // getPartner() {
    //   return this.$store.getters.getPartner;
    // },
  },
};
</script>

<style scoped>
.p-0 {
  padding: 0px !important;
}

.sub-areas > div > table > thead > tr {
  background-color: red;
  border-radius: 10px;
}
</style>
